{
  "required": {
    "default": "This field is required",
    "email": "Email is required",
    "password": "Password is required",
    "name": "Name is required",
    "firstName": "First name is required",
    "lastName": "Last name is required",
    "phone": "Phone number is required"
  },
  "format": {
    "email": "Please enter a valid email address",
    "phone": "Please enter a valid phone number",
    "url": "Please enter a valid URL",
    "date": "Please enter a valid date",
    "number": "Please enter a valid number",
    "integer": "Please enter a whole number"
  },
  "length": {
    "min": "Must be at least {{min}} characters",
    "max": "Must be no more than {{max}} characters",
    "exact": "Must be exactly {{length}} characters",
    "between": "Must be between {{min}} and {{max}} characters"
  },
  "password": {
    "min": "Password must be at least 8 characters",
    "uppercase": "Password must contain at least one uppercase letter",
    "lowercase": "Password must contain at least one lowercase letter",
    "number": "Password must contain at least one number",
    "special": "Password must contain at least one special character",
    "match": "Passwords do not match",
    "weak": "Password is too weak",
    "common": "This password is too common"
  },
  "range": {
    "min": "Must be at least {{min}}",
    "max": "Must be no more than {{max}}",
    "between": "Must be between {{min}} and {{max}}"
  },
  "file": {
    "required": "Please select a file",
    "size": "File size must be less than {{size}}",
    "type": "Invalid file type. Allowed types: {{types}}",
    "count": "You can upload maximum {{count}} files"
  },
  "custom": {
    "terms": "You must accept the terms and conditions",
    "age": "You must be at least {{age}} years old",
    "unique": "This {{field}} is already taken",
    "exists": "This {{field}} does not exist",
    "expired": "This {{field}} has expired",
    "invalid": "Invalid {{field}}"
  }
}
